import React from 'react';
import {Image} from "react-bootstrap";
import {Link} from "react-router-dom";
import './posterCard.css'

function PosterCard({to,posterImg, header, statusColor, statusText, date }) {
    return (
        <Link to={to} className="poster-card-wrapper">
            <div className="image-wrapper">
                <Image src={posterImg}/>
            </div>
            <div className="text-wrapper p-3">

                <h3 className={'mb-5'}>
                    {header}
                </h3>
                <div className="details-wrapper">
                    <div className="status">
                        <span style={{backgroundColor: statusColor}}> </span>
                        <p>{statusText}</p>
                    </div>
                    <p className="date">{date}</p>
                </div>

            </div>
        </Link>
    );
}

export default PosterCard;